<!--
  The following lines are duplicated on purpose
  to ensure input[type=number] number directive is working correctly
  if type attribute is a runtime value, not a static one it will break the directive
  and the input will not parse numbers when writing to the form
  -->
<ion-item fill="outline" lines="none">
  <ion-input
    labelPlacement="floating"
    [label]="showLabel ? customField.name : undefined"
    *ngIf="customField.type === 'text'"
    autocomplete="off"
    [formControl]="internalValue"
    [placeholder]="placeholder"
    type="text">
  </ion-input>

  <ion-input
    labelPlacement="floating"
    [label]="showLabel ? customField.name : undefined"
    *ngIf="customField.type === 'number'"
    autocomplete="off"
    [formControl]="internalValue"
    [placeholder]="placeholder"
    type="number">
  </ion-input>

</ion-item>
